var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 6.29279C8.31658 5.90227 7.68342 5.90227 7.29289 6.29279L0.928933 12.6568C0.538408 13.0473 0.538408 13.6804 0.928933 14.071C1.31946 14.4615 1.95262 14.4615 2.34315 14.071L8 8.41411L13.6569 14.071C14.0474 14.4615 14.6805 14.4615 15.0711 14.071C15.4616 13.6804 15.4616 13.0473 15.0711 12.6568L8.70711 6.29279ZM9 7V6.9999H7V7H9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 0.292793C8.31658 -0.097731 7.68342 -0.097731 7.29289 0.292793L0.928933 6.65675C0.538408 7.04728 0.538408 7.68044 0.928933 8.07097C1.31946 8.46149 1.95262 8.46149 2.34315 8.07097L8 2.41411L13.6569 8.07097C14.0474 8.46149 14.6805 8.46149 15.0711 8.07097C15.4616 7.68044 15.4616 7.04728 15.0711 6.65675L8.70711 0.292793ZM9 1V0.9999H7V1H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowWhite);
export default __webpack_public_path__ + "static/media/double-arrow-white.728f1fe6fb9425127ea1a05a1771efa3.svg";
export { ForwardRef as ReactComponent };